import {DoppeActionGoalType} from "../doppe-action-types/doppe-action-type";
import {DoppeActionCTAType} from "./doppe-action-cta-button";
import type {DoppeActionCTAButton, DoppeActionSettingsCTAButtonSettings} from "./doppe-action-cta-button";
import type {DoppeDtoAction} from "./doppe-dto-action";

export function doppeActionCtaButtonTypeGetGoalType(type: DoppeActionCTAType) {

    switch (type) {
        case DoppeActionCTAType.Whatsapp: {
            return DoppeActionGoalType.WhatsappClick;
        }
        case DoppeActionCTAType.Call: {
            return DoppeActionGoalType.CallButtonClick;
        }
        case DoppeActionCTAType.OpenBlogPost:
        case DoppeActionCTAType.OpenPage:
        case DoppeActionCTAType.OpenProduct:
        case DoppeActionCTAType.OpenService:
        case DoppeActionCTAType.OpenEvent:
        case DoppeActionCTAType.OpenPricingPlan:
        case DoppeActionCTAType.Link: {
            return DoppeActionGoalType.Click;
        }
        case DoppeActionCTAType.Email: {
            return DoppeActionGoalType.EmailButtonClick;
        }
        case DoppeActionCTAType.Navigate: {
            return DoppeActionGoalType.NavigateButtonClick;
        }
        case DoppeActionCTAType.NavigateV2: {
            return DoppeActionGoalType.NavigateButtonClick;
        }
        case DoppeActionCTAType.FacebookMessage: {
            return DoppeActionGoalType.FacebookMessageButtonClick;
        }
        case DoppeActionCTAType.InstagramMessage: {
            return DoppeActionGoalType.InstagramMessageButtonClick;
        }
        case DoppeActionCTAType.SaveContact: {
            return DoppeActionGoalType.SaveContact;
        }
        case DoppeActionCTAType.Share: {
            return DoppeActionGoalType.Share;
        }
        case DoppeActionCTAType.Checkout: {
            return DoppeActionGoalType.Payment;
        }
        case DoppeActionCTAType.IsracardPay: {
            return DoppeActionGoalType.Payment;
        }
        case DoppeActionCTAType.WixEcomCheckout: {
            return DoppeActionGoalType.Payment;
        }
        case DoppeActionCTAType.FormSubmit: {
            return DoppeActionGoalType.FormSubmission;
        }
        case DoppeActionCTAType.BuyNow: {
            return DoppeActionGoalType.Click;
        }
        case DoppeActionCTAType.AddToCart: {
            return DoppeActionGoalType.Click;
        }
        case DoppeActionCTAType.BookNow: {
            return DoppeActionGoalType.Click;
        }
        case DoppeActionCTAType.Register: {
            return DoppeActionGoalType.Click;
        }
        case DoppeActionCTAType.ContactButton: {
            return DoppeActionGoalType.Click;
        }
        case DoppeActionCTAType.DownloadFile:
        case DoppeActionCTAType.DownloadMainFile: {
            // Paid downloads also report Payment via the post-checkout claim flow;
            // the click itself is reported as a generic Click for both free and paid.
            return DoppeActionGoalType.Click;
        }
        case DoppeActionCTAType.AddToCalendar: {
            return DoppeActionGoalType.Click;
        }
    }
}

/**
 * Resolve the Wix Media file id from the first DownloadFile CTA button on the
 * given action, if any. Used by the post-checkout Claim Download flow to
 * recover the file id directly from the page props (the buyer-facing modal
 * needs it to call the server's `generatePaidDownloadFileUrl` endpoint).
 *
 * Cross-tenant requests still fail server-side because the signed URL is
 * scoped to the creator's MetaSite, so trusting the file id from the page
 * props is safe here.
 */
export function doppeActionCtaButtonsFindDownloadFileMediaFileId(
    action: DoppeDtoAction
): string | null {
    const ctaButtons = (action.settings as { ctaButtons?: DoppeActionCTAButton.MultipleButton[] }).ctaButtons;
    for (const button of ctaButtons ?? []) {
        if (button.settings?.type === DoppeActionCTAType.DownloadFile) {
            return (button.settings as DoppeActionSettingsCTAButtonSettings.DownloadFile).fileId;
        }
    }
    return null;
}